module.exports = __webpack_public_path__ + "static/media/partner_form_img.12ef2327.png";